import { CheckboxControl } from "common/components/Checkbox/CheckboxControl";
import { IFieldBaseProps } from "common/components/Field";
import { FormContext } from "common/components/Form/FormContext";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { parsePath } from "common/helpers/FormPath";
import isEqual from "lodash/isEqual";

export interface ICheckboxProps extends IFieldBaseProps<"checkbox"> {
  size?: "sm" | "md";
  label: string;
  customCheckedValue?: string | object;
  customUncheckedValue?: string | object;
  border?: boolean;
  noBackground?: boolean;
  readOnlyValue?: boolean;
  namespace?: string;
  hideLabel?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Checkbox: React.FC<ICheckboxProps> = ({
  id,
  label,
  name,
  disabled,
  type,
  size = "md",
  customCheckedValue,
  customUncheckedValue,
  border = false,
  noBackground = false,
  readOnlyValue,
  namespace,
  hideLabel = false,
  onChange,
}) => {
  // Constants
  const { rootPath, updateFormReducer } = React.useContext(FormContext);
  // Hooks
  const dispatch = useDispatch();

  // Selectors
  const path = parsePath(name);
  let isChecked = useSelector((state: any) => state.getIn(rootPath.concat(path)));
  if (customCheckedValue && customUncheckedValue) {
    if (isEqual(isChecked, customCheckedValue)) {
      isChecked = true;
    } else if (isEqual(isChecked, customUncheckedValue)) {
      isChecked = false;
    }
  }

  // Methods
  const handleInput = (checked: boolean) => {
    let value: any = checked;

    if (customCheckedValue && customUncheckedValue !== undefined) {
      value = checked ? customCheckedValue : customUncheckedValue;
    }

    if (onChange) {
      onChange(checked);
    }

    dispatch(updateFormReducer({ rootPath, name, value: value }));
  };

  // Lifecycle
  return (
    <CheckboxControl
      id={id}
      label={label}
      hideLabel={hideLabel}
      isChecked={readOnlyValue ?? isChecked}
      name={name}
      type={type}
      disabled={disabled}
      size={size}
      onChange={handleInput}
      border={border}
      noBackground={noBackground}
      namespace={namespace}
    />
  );
};
